import React from 'react'
import styled from 'styled-components'
import { string } from 'prop-types'

const StyledIframe = styled.iframe`
  width: 100%;
`

export const IframeEmbed = ({ src, height, ...rest }) => {
  return (
    <StyledIframe
      src={src}
      height={height}
      allowFullScreen
      frameBorder='0'
      scrolling='no'
      {...rest}
    />
  )
}

IframeEmbed.propTypes = {
  src: string,
  height: string,
}
